import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=f858bb44&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=f858bb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f858bb44",
  null
  
)

/* custom blocks */
import block0 from "./EditContact.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports